import {
  Button,
  TableCell,
  TableRow,
  Typography,
  Box,
  Dialog,
  Stack,
  TextField,
  DialogActions,
  DialogTitle,
} from '@mui/material';
import SvgIconStyle from 'components/SvgIconStyle';
import { renderRowCreatedAt } from 'utils/renderTableCell';
import { useState } from 'react';
import { renderStatus } from 'utils/webinar/getStatus';
import { PATH_DASHBOARD } from 'routes/paths';

export const RejectHistory = ({ open, onClose, content, status }) => (
    <Dialog open={open} onClose={onClose}>
      <Box sx={{ minWidth: 600, padding: '1rem' }}>
        <DialogTitle>
          <Stack flexDirection="row" alignItems="center" justifyContent="space-between">
            <Box onClick={onClose}>
              <SvgIconStyle src="/icons/close_square_icon.svg" sx={{ width: 20, height: 20, cursor: 'pointer' }} />
            </Box>
            <Typography fontSize={20} fontWeight={700}>
              {status === 2 ? 'درخواست تایید شده' : 'دلیل رد درخواست'}
            </Typography>
            <div />
          </Stack>
        </DialogTitle>

        <Stack gap={3}>
          <TextField
            label={status === 2 ? 'تاریخ تایید درخواست' : 'تاریخ رد درخواست'}
            value={renderRowCreatedAt('fa-IR', content?.at)}
            fullWidth
          />

          {status === 6 && <TextField label="علت رد درخواست" value={content?.reason} fullWidth />}
          {status === 6 && (
            <TextField label="توضیحات کارشناس" value={content?.description} multiline minRows={5} fullWidth />
          )}

          <TextField label={status === 2 ? 'تایید شده توسط' : 'رد شده توسط'} value={content?.by} fullWidth />
        </Stack>

        <DialogActions>
          <Button variant="contained" size="medium" sx={{ mx: 'auto' }} onClick={onClose}>
            بستن
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );

export const AllWebinarRow = ({ row, index }) => {
  const [openRejectHistory, setOpenRejectHistory] = useState(false);

  return (
    <>
      <TableRow key={index} hover>
        <TableCell align="center">
          <Typography>{index + 1}</Typography>
        </TableCell>
        <TableCell align="center">
          <Typography>{row?.title || 'عنوان نامشخص'}</Typography>
        </TableCell>
        <TableCell align="center">
          <Typography>{renderRowCreatedAt('fa-IR', row?.createdAt)}</Typography>
        </TableCell>
        <TableCell align="center">
          <Typography>{renderRowCreatedAt('fa-IR', row?.liveAt)}</Typography>
        </TableCell>
        <TableCell align="center">
          <Typography>{renderRowCreatedAt('fa-IR', row?.liveAt, false, true)}</Typography>
        </TableCell>
        <TableCell align="center">
          <Typography>{row?._id?.split('_')[0]}</Typography>
        </TableCell>
        <TableCell align="center">
          <Typography>{row?.products?.length > 0 ? 'دارد' : 'ندارد'}</Typography>
        </TableCell>
        <TableCell align="center">
          <Typography>{row?.siteDomain || '-'}</Typography>
        </TableCell>
        <TableCell align="center">
          <Typography>{row?.category?.name || '-'}</Typography>
        </TableCell>
        <TableCell align="center">
          <Typography>{renderStatus(row?.finished?.byAdmin ? 'STOPPED' : row?.status)}</Typography>
        </TableCell>
        <TableCell align="center">
          {row?.status !== 1 ? (
            <Button
              variant="contained"
              color={row?.status === 6 ? 'error' : 'success'}
              onClick={() => setOpenRejectHistory(true)}
            >
              مشاهده
            </Button>
          ) : (
            '-'
          )}
        </TableCell>
        {/* <TableCell align="center">
          <a
            href={`https://${row?.status !== 4 ? row?.host : row?.host.split('!')[2]}.aff.bizmlm.ir`}
            target="_blank"
            rel="noreferrer"
          >
            <Typography>{row?.status !== 4 ? row?.host : row?.host.split('!')[2]}</Typography>
          </a>
        </TableCell> */}
        <TableCell align="center" sx={{ display: 'flex' }}>
          <div aria-hidden onClick={() => window?.open(PATH_DASHBOARD.webinar.detail(row?._id), '_blank')}>
            <SvgIconStyle src="/icons/send_icon.svg" sx={{ width: 20, height: 20, cursor: 'pointer' }} />
          </div>
          <div style={{ margin: '0px 10px' }}>
            <SvgIconStyle src="/icons/dots.svg" sx={{ width: 20, height: 20, cursor: 'pointer' }} />
          </div>
        </TableCell>
      </TableRow>
      <RejectHistory
        open={openRejectHistory}
        onClose={() => setOpenRejectHistory(false)}
        content={{
          by: row?.accepted?.by || row?.rejection?.by,
          at: row?.accepted?.at || row?.rejection?.at,
          reason: row?.rejection?.reason,
          description: row?.rejection?.description,
        }}
        status={row?.status}
      />
    </>
  );
};
